import React from 'react';
import style from './Works.module.scss';

require('dotenv').config();

const works = process.env.REACT_APP_BITRIX_UNAVAILABLE === 'true';

const Works = () => {
  if (works) {
    return (
      <div className={style.works}>
        <h2>Ведутся технические работы</h2>
      </div>
    );
  }
  return null;
};

export { Works, works };
